import React from 'react';
// import { Animated } from 'react-animated-css';
import { Col, Row, Table } from 'react-bootstrap';
import styled from 'styled-components';

const StyledRow = styled(Row)`
  height: 100%;
  align-items: center;
  .table {
    margin-bottom: 0;
    background: var(--bac-white);
    thead > tr {
      vertical-align: middle;
      text-align: center;
    }
    thead > tr > th:not(:last-child) {
      border-right: 2px solid var(--bac-gray);
    }
    .total-cell {
      & > td {
        background: var(--bac-blue);
        color: var(--bac-white);
      }
      box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.12);
      border-radius: 2px;
    }
  }
  .table > :not(caption) > * > * {
    border-bottom: 2px solid var(--bac-widgetBackground);
  }
`;
const BacTable = ({data, dataHead}) => {
  return (
      <StyledRow>
        <Col md={12}>
        <Table responsive>
        <thead>
          <tr>
            {dataHead.map((item, index) => <th key={index}>{item}</th>)}
          </tr>
        </thead>
        <tbody>
          
            {data.map((elt, index) => {
              const isLast = index === data.length - 1;
              return (
              <tr key={index} className={isLast ? 'total-cell' : ''}>
                
                {Object.keys(elt).map((keyName, keyIndex) => {
                  return (
                  <td key={keyIndex}>
                    {
                      keyName === 'ratio' ? 
                      `${elt.center === 'Total' ? ((elt.nb_ano / elt.nb_eqf) * 100).toFixed(2) : elt[keyName]}%`
                       : elt[keyName]
                    }
                  </td>
                  )
                })}
              </tr>
            )})}
        </tbody>
      </Table>
        </Col>
      </StyledRow>
  );
};

export default BacTable;
